import { Modal } from "@xcorejs/ui";
import { FC, useEffect } from "react";

// If podcast id is specified, renders corresponding podcast version. If not, renders player with list of all episodes
const PodcastEpisodeModal: FC<{ podcastId: string | null }> = ({ podcastId }) => {
  const buzzsproutAccountId = process.env.BUZZSPROUT_ACCOUNT_ID ?? "2411650";

  // Script has to run like this because React does not support automatic script executions in the JSX
  useEffect(() => {
    const script = document.createElement("script");
    script.src = podcastId
      ? `https://www.buzzsprout.com/${buzzsproutAccountId}/episodes/${podcastId}.js?container_id=buzzsprout-player-${podcastId}&player=small`
      : `https://www.buzzsprout.com/${buzzsproutAccountId}.js?container_id=buzzsprout-large-player&player=large`;
    script.type = "text/javascript";
    script.charset = "utf-8";
    script.async = true;

    document.body.appendChild(script);

    // Remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, [buzzsproutAccountId, podcastId]);

  return (
    <Modal
      size="lg"
      _overlay={{
        zIndex: 5
      }}
    >
      <div id={podcastId ? `buzzsprout-player-${podcastId}` : "buzzsprout-large-player"}></div>
    </Modal>
  );
};

export default PodcastEpisodeModal;
